import {
  PolicyArticleTitle,
  PolicyContainer,
  PolicyList,
  PolicySectionTitle,
  PolicyText,
  PolicyTitle,
  PolicyVersion,
} from "styles/PolicyCommon";

const Service = () => {
  return (
    <PolicyContainer>
      <h1 className="hide">열달후에</h1>
      <PolicyTitle>[열달후에] 서비스 이용약관</PolicyTitle>
      <PolicyVersion>ver.2.2</PolicyVersion>

      <PolicySectionTitle>
        &lt;제 1 장&gt; 환영합니다! ‘열달후에’와 함께 소중한 순간을 채워보세요.
      </PolicySectionTitle>
      <PolicyText>
        ‘열달후에’는 앱을 통해 임신 준비부터 출산, 육아까지의 기록, 병원,
        산후조리원 등 필요한 정보 검색, 다른 회원과의 커뮤니케이션, 콘텐츠 제공
        등 여러분의 생활에 편리함을 더할 수 있는 다양한 서비스를 제공하고
        있습니다. 여러분은 인터넷 이용이 가능한 단말기를 통해 서비스를 자유롭게
        이용하실 수 있습니다. 본 약관은 여러분이 서비스를 이용하는 데 필요한
        권리, 의무 및 책임사항, 이용조건 및 절차 등 기본적인 사항을 규정하고
        있으므로 조금만 시간을 내서 주의 깊게 읽어주시기 바랍니다.
      </PolicyText>
      <PolicyArticleTitle>제 1 조 목적 및 정의</PolicyArticleTitle>
      <PolicyText>
        커넥트아이의 ‘열달후에’(이하 ‘서비스’)를 이용해 주셔서 감사합니다. 본
        약관은 서비스 이용자가 주식회사 커넥트아이(이하 ‘회사’)이 제공하는
        ‘열달후에’ 서비스에 회원으로 가입하고 이를 이용함에 있어 회사와 회원(본
        약관에 동의하고 회원등록을 완료한 서비스 이용자. 이하 ‘회원’)의
        권리∙의무 및 책임사항을 규정함을 목적으로 합니다.
      </PolicyText>
      <PolicyArticleTitle>제 2 조 약관의 효력 및 변경</PolicyArticleTitle>
      <PolicyList>
        <li>
          1. 본 약관의 내용은 앱 서비스의 화면에 게시하거나 기타의 방법으로
          공지하고, 본 약관에 동의한 회원 모두에게 그 효력이 발생합니다.
        </li>
        <li>
          2. 회사는 필요한 경우 관련 법령을 위배하지 않는 범위 내에서 본 약관을
          변경할 수 있습니다. 본 약관이 변경되는 경우 회사는 변경사항을 시행일자
          15일 전부터 회원에게 서비스 공지사항에서 공지 또는 통지하는 것을
          원칙으로 하며, 피치 못하게 회원에게 불리한 내용으로 변경할 경우에는
          시행일자 30일 전부터 계정으로 등록된 이메일 주소로 이메일 발송 또는
          회원이 등록한 휴대전화번호로 문자 메시지를 발송하는 방법 등을 통해
          개별적으로 알려 드리겠습니다.
        </li>
        <li>
          3. 회사가 전 항에 따라 공지 또는 통지 시 공지 또는 통지일로부터
          개정약관 시행일 7일 후까지 거부의사를 표시하지 아니하면 승인한 것으로
          본다는 뜻을 명확하게 고지하였음에도 회원의 의사표시가 없는 경우에는
          변경된 약관을 승인한 것으로 봅니다.
        </li>
        <li>
          4. 회원은 변경된 약관에 대하여 거부의사를 표시함으로써 이용계약의
          해지를 선택할 수 있습니다. 이용계약의 해지는 서비스 내 회원탈퇴를 통해
          가능합니다.
        </li>
        <li>
          5. 본 약관은 본 약관에 동의한 날로부터 본 약관 제12조에 따른
          이용계약의 해지 시까지 적용하는 것을 원칙으로 합니다. 단, 본 약관의
          일부 조항은 이용계약의 해지 후에도 유효하게 적용될 수 있습니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>제 3 조 약관 외 준칙</PolicyArticleTitle>
      <PolicyText>
        본 약관에 규정되지 않은 사항에 대해서는 관련 법령 또는 서비스의 운영정책
        및 규칙 (이하 ‘운영정책’)의 규정에 따릅니다. 또한 본 약관과 운영정책의
        내용이 충돌할 경우 운영정책에 따릅니다.
      </PolicyText>

      <PolicySectionTitle>
        &lt;제 2 장&gt; 회원의 가입 및 관리
      </PolicySectionTitle>
      <PolicyArticleTitle>제 4 조 회원가입절차</PolicyArticleTitle>
      <PolicyList>
        <li>
          1. 서비스 이용자가 본 약관을 읽고 “동의” 버튼을 누르거나 “확인” 등에
          체크하는 방법을 취한 경우 본 약관에 동의한 것으로 간주합니다.
        </li>
        <li>
          2. 회사의 서비스 이용을 위한 회원가입은 서비스 이용자가 제1항과 같이
          동의한 후, 회사가 정한 회원가입 방법에 따라 회원 ID(이메일 계정)를
          포함한 필수사항을 입력하고, “등록하기” 내지 “확인” 버튼을 누르는
          방법으로 합니다. 다만, 회사가 필요하다고 인정하는 경우 회원에게 별도의
          서류를 제출하도록 할 수 있습니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>
        제 5 조 회원등록의 성립과 유보 및 거절
      </PolicyArticleTitle>
      <PolicyList>
        <li>
          1. 회원등록은 제4조에 정한 절차에 의한 서비스 이용자의 회원가입 신청과
          회사의 회원등록 승낙에 의하여 성립합니다. 회사는 회원가입 신청자가
          필수사항 등을 성실히 입력하여 가입신청을 완료하였을 때에는 원칙적으로
          가입을 자동으로 승낙합니다. 다만, 회사는 아래 각 호의 경우에는 그
          사유가 해소될 때까지 승낙을 유보하거나 승낙을 취소할 수 있습니다.
          <ul>
            <li>
              ① 다른 사람의 명의나 이메일 주소 등 개인정보를 이용하여 서비스에
              가입한 것으로 판단되는 경우
            </li>
            <li>② 서비스 제공 설비 용량에 현실적인 여유가 없는 경우</li>
            <li>
              ③ 서비스 제공을 위한 기술적인 부분에 문제가 있다고 판단되는 경우
            </li>
            <li>④ 기타 회사가 재정적, 기술적으로 필요하다고 인정하는 경우</li>
            <li>
              ⑤ 회사로부터 서비스 이용정지 조치 등을 받은 자가 서비스 이용계약을
              임의로 해지하고 재가입을 신청하는 경우
            </li>
            <li>
              ⑥ 기타 관련 법령에 위배되거나 세부지침 등 회사가 정한 기준에
              반하는 경우
            </li>
          </ul>
        </li>
        <li>
          2. 만약 회원이 위 조건에 위반하여 서비스에 가입한 것으로 판명된 때에는
          회사는 즉시 해당 회원의 서비스 이용을 정지시키거나 계정을 삭제하는 등
          적절한 제한을 할 수 있습니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>제 6 조 회원 ID 등의 관리책임</PolicyArticleTitle>
      <PolicyList>
        <li>
          1. 회원은 서비스 이용을 위한 회원 ID, 비밀번호의 관리에 대한 책임,
          본인 ID의 제3자에 의한 부정사용 등 회원의 고의∙과실로 인해 발생하는
          모든 불이익에 대한 책임을 부담합니다. 단, 이것이 회사의 고의∙과실로
          인하여 야기된 경우는 회사가 책임을 부담합니다.
        </li>
        <li>
          2. 회원은 회원 ID, 비밀번호 및 서비스 잠금 비밀번호, 추가정보 등을
          도난 당하거나 제3자가 사용하고 있음을 인지한 경우에는 즉시 본인의
          비밀번호를 수정하는 등의 조치를 취해야 하며 즉시 이를 회사에 통보하여
          회사의 안내를 따라야 합니다.
        </li>
        <li>
          3. 네이버, 카카오톡, 페이스북, 애플 로그인 등 SNS 간편 로그인을 이용할
          경우 해당 SNS에서 발송되는 연동 토큰을 통해 로그인이 되는 방식이므로
          서비스 내에서 비밀번호 찾기, 아이디 찾기는 불가능 합니다.
        </li>
      </PolicyList>

      <PolicySectionTitle>&lt;제 3 장&gt; 서비스 이용</PolicySectionTitle>
      <PolicyArticleTitle>제 7 조 다양한 서비스의 제공</PolicyArticleTitle>
      <PolicyList>
        <li>
          1. 서비스 이용은 회원가입 이후 회사의 서비스 사용승낙 직후부터
          가능합니다. 회원은 서비스를 구성하는 다이어리, 가이드, 찾기 등의
          서비스를 회원이 원하는 때에 자유롭게 이용할 수 있습니다.
        </li>
        <li>
          2. 다만 일부 하위 서비스의 경우 별도의 이용약관에 동의해야 이용이
          가능하며, 필요한 추가 정보를 기재하거나 이메일 주소 승인 또는 본인
          인증 등 회사가 정한 인증 절차를 완료한 후 조건이 성립된 경우 서비스를
          이용할 수 있습니다. 열달맘톡 서비스의 경우에도 최초 이용 시점에 휴대폰
          본인 인증 절차 완료 후 성인 여성으로 확인되어야 서비스 이용이
          가능합니다.
        </li>
        <li>
          3. 회사는 더 나은 서비스를 위하여 서비스에 필요한 소프트웨어의
          업데이트 버전을 제공할 수 있습니다. 소프트웨어의 업데이트에는 중요한
          기능의 추가 또는 불필요한 기능의 제거 등이 포함되어 있습니다. 보다
          나은 서비스를 이용할 수 있도록 꾸준히 업데이트하여 주시기 바랍니다.
        </li>
        <li>
          4. 회사는 더 나은 서비스의 제공을 위하여 회원에게 서비스의 이용과
          관련된 각종 고지, 관리 메시지 및 기타 광고를 비롯한 다양한 정보를
          서비스 내에 표시하거나 회원의 계정 정보에 등록되어 있는 연락처로 직접
          발송할 수 있습니다. 단, 회사는 회원이 수신 동의를 하지 않은 영리
          목적의 광고성 이메일, 푸시 또는 문자 메시지 등을 발송하지 아니합니다.
        </li>
        <li>
          5. 서비스 이용 중 시스템 오류 등 문제점을 발견하신다면 언제든지
          고객센터로 알려주시기 바랍니다.
        </li>
        <li>
          6. 서비스를 이용하는 과정에서 Wi-Fi 무선인터넷을 사용하지 않고,
          가입하신 이동통신사의 통신망에 연결하여 이용하는 경우 이동통신사로부터
          데이터 통신요금이 부과될 수 있는 점을 유의하여 주시기 바랍니다. 서비스
          이용 과정에서 발생하는 데이터 통신요금은 회원의 비용과 책임 하에
          이동통신사에 납부하셔야 합니다. 데이터 통신요금에 대한 자세한 안내는
          가입하신 이동통신사에 문의하시기 바랍니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>제 8 조 서비스의 중단 및 종료</PolicyArticleTitle>
      <PolicyList>
        <li>
          1. 서비스 및 보안과 관련된 설비를 지속적이고 안정적으로 제공하는데
          적합하도록 유지해야 하며, 점검 또는 복구 등의 조치를 성실히 이행하여야
          합니다.
        </li>
        <li>
          2. 이용시간은 회사의 업무상 또는 기술상 불가능한 경우를 제외하고는
          연중무휴 1일 24시간(00:00-24:00)을 원칙으로 합니다. 다만, 아래 각 호의
          경우 서비스의 전부 또는 일부를 제한하거나 중지 또는 종료할 수
          있습니다.
          <ul>
            <li>
              ① 서비스용 설비의 유지·보수 등을 위한 정기 또는 임시 점검의 경우
            </li>
            <li>
              ② 정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 서비스
              이용에 지장이 있는 경우
            </li>
            <li>
              ③ 관계사와의 계약 종료, 정부의 명령/규제 등 회사의 제반 사정으로
              서비스의 전부 또는 일부를 유지할 수 없는 경우
            </li>
            <li>
              ④ 기타 천재지변, 국가비상사태 등 불가항력적 사유가 있는 경우
            </li>
          </ul>
        </li>
        <li>
          3. 전항에 의한 서비스 중단 또는 종료의 경우에는 미리 제16조에서 정한
          방법으로 회원에게 통지 내지 공지하겠습니다. 다만, 회사로서도 예측할 수
          없거나 통제할 수 없는 사유(회사의 과실이 없는 디스크 내지 서버 장애,
          외부 데이터 연동에 필요한 외부 시스템 장애, 시스템 다운 등)로 인한
          경우에는 사전 공지가 불가능하며, 이에 대한 양해 부탁드립니다. 이러한
          경우에도 회사가 상황을 파악하는 즉시 최대한 빠른 시일 내에 서비스를
          복구하도록 노력하겠습니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>제 9 조 게시물의 관리</PolicyArticleTitle>
      <PolicyList>
        <li>
          1. 회원의 게시물이 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하
          ‘정보통신망법’)및 저작권법 등 관련 법령에 위반되는 내용을 포함하는
          경우에 권리자는 회사에 관련 법령이 정한 절차에 따라 해당 게시물의
          게시중단 및 삭제 등을 요청할 수 있으며, 회사는 관련 법령에 따라 조치를
          취합니다.
        </li>
        <li>
          2. 회사는 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가
          있거나 기타 회사의 정책 및 관련 법령에 위반되는 경우에는 관련 법령에
          따라 해당 게시물에 대해 임시조치, 삭제 등을 취할 수 있습니다.
        </li>
        <li>
          3. 위와 관련된 세부 절차는 정보통신망법 및 저작권법이 규정한 범위
          내에서 회사가 정한 신고 절차에 따릅니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>
        제 10 조 권리의 귀속 및 저작물의 이용
      </PolicyArticleTitle>
      <PolicyList>
        <li>
          1. 회원은 사진, 글, 정보, 영상 또는 회사에 대한 의견이나 제안 등
          콘텐츠(이하 ‘게시물’)를 서비스 내에 게시할 수 있으며, 이러한 게시물에
          대한 저작권을 포함한 지적재산권은 당연히 게시한 회원이 계속하여
          보유합니다.
        </li>
        <li>
          2. 회원이 작성한 게시물은 검색결과 내지 맞춤 콘텐츠 영역, 관련
          프로모션 등에도 노출될 수 있습니다. 해당 노출을 위해 필요한 범위
          내에서는 일부 수정, 복제, 편집되어 게시될 수 있습니다. 이 경우 회사는
          저작권법 규정을 준수하며, 회원은 언제든지 고객센터를 통해 해당
          게시물의 삭제 등의 조치를 취할 수 있습니다.
        </li>
        <li>
          3. 회사는 회원의 게시물이 관련 법령에 위반되거나 음란 게시물, 차별
          갈등을 조장하는 게시물, 도배 · 광고 · 홍보 · 스팸성 게시물, 계정을
          양도 또는 거래하는 내용의 게시물, 타인을 사칭하는 게시물 등이라고
          판단되는 경우 별도의 통보없이 삭제하거나 게시를 거부할 수 있습니다.
          다만 회사가 모든 콘텐츠를 검토할 의무가 있는 것은 아니므로 누군가
          회원의 권리를 침해하였다면 신고 또는 고객센터를 통해 도움을 받으실 수
          있습니다. 이와 관련된 구체적인 기준 등의 내용은 서비스 운영정책에서
          확인하실 수 있습니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>
        제 11조 서비스 이용의 제한 및 중지
      </PolicyArticleTitle>
      <PolicyList>
        <li>
          1. 회사는 아래 각 호의 1에 해당하는 사유가 발생한 경우에는 회원의
          서비스 이용을 제한하거나 중지시킬 수 있습니다.
          <ul>
            <li>
              ① 다른 회원의 ID 및 비밀번호를 도용하여 부당하게 서비스를
              이용하거나 명의자의 허락 없이 문자메시지(SMS) 인증 등을 수행하는
              행위
            </li>
            <li>
              ② 회사의 서비스를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복제
              또는 유통시키거나 상업적으로 이용하는 행위
            </li>
            <li>③ 타인의 명예를 손상시키거나 불이익을 주는 행위</li>
            <li>
              ④ 게시판 등에 음란물을 게재하거나 음란사이트를 연결(링크)하는 행위
            </li>
            <li>⑤ 회사 또는 제3자의 저작권 등 기타 권리를 침해하는 행위 </li>
            <li>
              ⑥ 서비스 내에 회사나 제3자 등에 대한 허위 사실을 게시하는 행위
            </li>
            <li>
              ⑦ 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형, 음성
              등을 타인에게 유포하는 행위
            </li>
            <li>
              ⑧ 서비스와 관련된 설비의 오동작이나 정보 등의 파괴 및 혼란을
              유발시키는 컴퓨터 바이러스 감염 자료를 등록 또는 유포하는 행위
            </li>
            <li>
              ⑨ 서비스의 운영을 고의로 방해하거나 안정적 운영을 방해하는 행위
            </li>
            <li>
              ⑩ 타인으로 가장하는 행위 및 타인과의 관계를 허위로 명시하는 행위
            </li>
            <li>⑪ 다른 이용자의 개인정보를 수집, 저장, 공개하는 행위</li>
            <li>
              ⑫ 자기 또는 타인에게 재산상의 이익을 주거나 타인에게 손해를 가할
              목적으로 허위의 정보를 유통시키는 행위
            </li>
            <li>⑬ 재물을 걸고 도박하거나 사행행위를 하는 행위</li>
            <li>
              ⑭ 윤락행위를 알선하거나 음행을 매개하는 내용의 정보를 유통시키는
              행위
            </li>
            <li>
              ⑮ 수치심이나 혐오감 또는 공포심을 일으키는 말이나 음향, 글이나
              화상 또는 영상을 계속하여 상대방에게 도달하게 하여 상대방의 일상적
              생활을 방해하는 행위
            </li>
            <li>
              ⑯ 정보통신망법 등 관련 법령에 의하여 그 전송 또는 게시가 금지되는
              정보(컴퓨터 프로그램 포함)를 전송 또는 게시하는 행위
            </li>
            <li>
              ⑰ 회사 또는 관계사의 직원이나 서비스의 운영자를 가장하거나 사칭
              또는 타인의 명의를 도용하여 글을 게시하는 행위
            </li>
            <li>
              ⑱ 컴퓨터 소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을
              방해, 파괴할 목적으로 고안된 소프트웨어 바이러스, 기타 다른 컴퓨터
              코드, 파일, 프로그램을 포함하고 있는 자료를 게시하는 행위
            </li>
            <li>
              ⑲ 스토킹(stalking), 욕설, 허위 또는 악의적 신고 남용 등 다른
              회원의 서비스 이용을 방해하는 행위
            </li>
            <li>
              ⑳ 기타 현행 법령, 본 약관 및 회사가 제공하는 서비스 관련
              세부지침을 위반하는 행위
            </li>
          </ul>
        </li>
        <li>
          2. 회원의 자격 혹은 나이에 따라 아래 각 호처럼 서비스 이용의 일부가
          제한될 수 있으며, 회사가 제공하는 서비스 중 관련 법령 등의 규정에
          의하여 성인인증이 필요한 경우 회원은 해당 서비스를 이용하기 위하여
          본인인증 등 회사가 제공하는 방법에 따라 실명정보를 회사에 제공하여야
          합니다.
          <ul>
            <li>
              ① 만19세 미만의 이용자는 정보통신망법 및 청소년보호법의 규정에
              의하여 청소년유해매체물은 이용할 수 없습니다. 이에 따라 만 19세
              미만의 이용자는 관련 정보를 담을 수 있는 열달맘톡 커뮤니티 서비스
              이용이 제한됩니다.
            </li>
            <li>
              ② 청소년유해매체물이 포함될 수 있는 서비스를 이용하시기 위해서는
              만 19세 이상이어야 하며, 정보통신망법 및 청소년보호법의 규정에
              의하여 실명인증을 통해 본인 및 연령 인증을 받으셔야 합니다. 인증을
              받지 않으시면 해당 서비스의 이용이 제한됩니다.
            </li>
            <li>
              ③ 여성 전용 열달맘톡 서비스의 경우 남성은 해당 서비스의 이용이
              제한됩니다.
            </li>
          </ul>
        </li>
        <li>
          3. 회사는 회원이 제1항의 행위를 하는 경우 회원의 위반행위 등을 조사할
          수 있고, 해당 게시물 등을 삭제 또는 임시 삭제하거나 회원의 서비스 전체
          또는 서비스를 구성하는 일부 개별 서비스의 이용을 잠시 또는 계속하여
          중단할 수 있습니다.
        </li>
        <li>
          4. 이용 제한은 위반 활동의 횟수 등 정도에 따라 한시적 제한에서 영구적
          제한으로 단계적 제한하는 것을 원칙으로 하지만 관련 법령에서 금지하는
          명백한 불법행위나 타인의 권리침해로서 긴급한 위험 또는 피해 차단이
          요구되는 사안에 대해서는 일방적으로 본 계약을 즉시 해지할 수 있으며,
          서비스 재가입 또는 일부 서비스의 재이용이 영구적으로 제한될 수
          있습니다.
        </li>
        <li>
          5. 그 밖에 서비스의 이용에 관한 자세한 사항은 서비스 운영정책을 참고해
          주시기 바랍니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>제 12 조 이용계약의 해지</PolicyArticleTitle>
      <PolicyList>
        <li>
          1. 회원이 회원 탈퇴를 하는 경우 서비스 이용계약도 자동으로 해지됩니다.
        </li>
        <li>
          2. 서비스 이용계약 해지를 원하는 우 회원은 언제든지 서비스 내 제공되는
          메뉴를 이용하여 탈퇴 신청을 할 수 있으며, 회사는 법령이 정하는 바에
          따라 신속히 처리하겠습니다.
        </li>
        <li>
          3. 서비스 이용계약이 해지되면 관련 법령 및 개인정보 처리방침에 따라
          회원의 일정 정보를 보유하는 경우를 제외하고는 회원이 다이어리에 저장한
          기록 등 모든 데이터는 삭제됩니다. 다만, 열달맘톡, 후기 등 다른
          회원들과 정보를 공유하는 서비스는 회원이 작성한 게시물이 다른 회원에
          의하여 찜 또는 다른 공유 기능으로 게시되거나, 회원이 다른 회원의
          게시물에 댓글 등을 추가하는 등 다양한 경우가 있으므로 탈퇴 시 자동
          삭제되지 않고 그대로 남아있습니다.
        </li>
        <li>
          4. 전항에 따라 회원이 삭제하지 않은 게시물은 다른 회원의 정상적인
          서비스 이용을 위하여 필요한 범위 내에서 삭제되지 않고 남아 있게
          됩니다. 따라서 해당 게시물 및 댓글은 삭제되지 않으므로 반드시 탈퇴
          신청 전에 삭제하시기 바랍니다. 단, 게시물은 남아있더라도 닉네임 등
          탈퇴 회원의 정보는 모두 삭제되어 노출되지 않습니다.
        </li>
        <li>
          5. SNS 간편 로그인으로 서비스 이용 도중에 서비스와 연동된 각 SNS
          계정을 탈퇴하는 경우 그 즉시 SNS 연동 토큰이 삭제되므로 서비스 이용이
          불가능하며, 서비스 이용 계약도 자동으로 해지됩니다. 따라서 SNS 간편
          로그인 계정으로 이용하시던 데이터는 제 12조 3항에 따라 처리되며 삭제된
          데이터는 더 이상 복구할 수 없습니다.
        </li>
        <li>
          6. 서비스 이용계약이 해지된 경우라도 다시 회원가입을 통해 서비스
          이용계약의 체결을 신청할 수 있습니다. 다만, 회원이 관련 법령, 본 약관
          및 세부지침을 준수하지 않아 서비스의 이용이 중단된 상태에서 이용계약을
          해지한 후 다시 이용계약 체결을 신청하는 경우에는 서비스 가입에
          일정기간 시간적 제한이 있거나 거부될 수 있습니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>제 13 조 개인정보의 보호</PolicyArticleTitle>
      <PolicyList>
        <li>
          1. 회사는 서비스를 제공하기 위하여 관련 법령의 규정에 따라
          회원으로부터 필요한 개인정보를 수집합니다. 회원의 개인정보는 서비스의
          원활한 제공을 위하여 회원이 동의한 목적과 범위 내에서만 이용됩니다.
          개인정보수집과 관련된 자세한 내용은 개인정보처리방침에 보다 상세히
          안내합니다.
        </li>
        <li>
          2. 개인정보의 안전한 처리는 회사에게 있어 가장 중요한 일 중
          하나입니다. 회사는 서비스의 제공과 관련하여 알게 된 회원의 개인정보를
          본인의 승낙 없이 제3자에게 누설, 배포하지 않고, 이를 보호하기 위하여
          노력합니다. 관련 법령에 의하거나 회원이 별도로 동의하지 않는 한 회사가
          회원의 개인정보를 제3자에게 제공하는 일은 결코 없으므로 안심하셔도
          좋습니다.
        </li>
        <li>
          3. 회사가 제3자와의 서비스 제공계약 등을 체결하여 회원에게 서비스를
          제공하는 경우 회사는 서비스의 제공을 위하여 제3자에게 제공되는
          구체적인 회원 정보를 명시하고, 회원의 개별적이고 명시적인 동의를 받은
          후 동의의 범위 내에서 해당 서비스의 제공 기간 동안에 한하여 회원의
          개인정보를 제3자와 공유하는 등 관련 법령을 준수합니다.
        </li>
        <li>
          4. 회사가 회원의 개인정보를 안전하게 처리하기 위하여 기울이는 노력이나
          기타 자세한 사항은 정보통신망법 및 회사가 별도로 정한
          “개인정보관리지침”에 따릅니다.
        </li>
      </PolicyList>

      <PolicySectionTitle>
        &lt;제 4 장&gt; 유료 서비스의 이용
      </PolicySectionTitle>
      <PolicyArticleTitle>
        제 14 조 유료서비스의 내용 등의 게시
      </PolicyArticleTitle>
      <PolicyList>
        <li>
          1. 회원이 일부 유료 서비스를 이용하기 위해서는 회사가 정한 정책에 따라
          유료서비스 이용 대금을 지급하여야 합니다.
        </li>
        <li>
          2. 회사는 다음 사항을 해당 유료 서비스의 이용초기화면이나 상세 페이지
          등에 회원이 알기 쉽게 표시합니다.
          <ul>
            <li>① 유료 서비스의 명칭 또는 제호</li>
            <li>
              ② 유료 서비스 제작/제공자의 성명(법인인 경우에는 법인의 명칭),
              주소, 전화번호
            </li>
            <li>③ 유료 서비스의 내용, 이용방법, 이용료 기타 이용조건</li>
          </ul>
        </li>
        <li>
          3. 회사의 유료 서비스의 이용가능기기 및 이용에 필요한 최소한의
          기술사양은 권장사양정보에 따릅니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>
        제 15 조 유료 서비스 이용 계약의 성립
      </PolicyArticleTitle>
      <PolicyList>
        <li>
          1. 회원은 회사가 제공하는 다음 또는 이와 유사한 절차에 의하여
          이용신청을 합니다. 회사는 계약 체결 전에 각 호의 사항에 관하여 회원이
          정확하게 이해하고 실수 또는 착오 없이 거래 수 있도록 정보를
          제공합니다.
          <ul>
            <li>① 유료 서비스의 확인 및 선택</li>
            <li>② 결제방법의 선택 및 결제정보의 입력</li>
            <li>
              ③ 유료 서비스의 이용신청에 관한 확인 또는 회사의 확인에 대한 동의
            </li>
          </ul>
        </li>
        <li>
          2. 회사는 회원의 이용신청이 다음 각 호에 해당하는 경우에는 승낙하지
          않거나 승낙을 유보할 수 있습니다.
          <ul>
            <li>① 실명이 아니거나 타인의 명의를 이용한 경우</li>
            <li>
              ② 허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은
              경우
            </li>
            <li>
              ③ 미성년자가 청소년보호법에 의해서 이용이 금지되는 유료서비스를
              이용하고자 하는 경우
            </li>
            <li>
              ④ 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는
              경우
            </li>
            <li>
              ⑤ 열달후에 서비스의 회원 자격을 상실하거나 이용제재를 받은 경우
            </li>
            <li>
              ⑥ 미성년자가 청소년보호법에 의해서 이용이 금지되는 유료서비스를
              이용하고자 하는 경우
            </li>
            <li>⑦ 기타 회원의 귀책사유로 승인이 불가능하다고 판단되는 경우</li>
          </ul>
        </li>
        <li>
          3. 회원이 유료 서비스를 이용하기 위해서는 해당 유료 서비스의
          이용조건에 따라 이용요금을 지급하여야 하며, 유료 서비스 이용계약의
          성립시기는 신청절차 상에서 ‘구매완료’ 등을 표시한 시점으로 합니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>
        제 16 조 유료 서비스 이용을 위한 결제 수단
      </PolicyArticleTitle>
      <PolicyList>
        <li>
          1. 유료 서비스에서 사용할 수 있는 이용요금 결제수단은 다음 각 호와
          같습니다. 다만, 회사는 회원이 선택한 결제수단에 대하여 어떠한 명목의
          수수료도 추가하여 징수하지 않습니다.
          <ul>
            <li>① 선불카드, 직불카드, 신용카드 등의 각종 카드 결제</li>
            <li>② 전화 또는 휴대전화를 이용한 결제</li>
            <li>
              ③ 폰뱅킹, 인터넷뱅킹, 메일뱅킹, 온라인 무통장 입금 등의 각종
              계좌이체
            </li>
            <li>
              ④ 회사가 제휴사를 통해 제공하는 선불전자지급수단을 통한 결제
            </li>
            <li>⑤ 전자화폐에 의한 결제</li>
            <li>⑥ 회사와 계약을 맺었거나 회사가 인정한 상품권에 의한 결제</li>
            <li>⑦ 캐시백, 신용카드등의 포인트에 의한 결제</li>
            <li>⑧ 기타 전자적 지급방법에 의한 대금지급 등</li>
          </ul>
        </li>
        <li>
          2. 회원은 유료 서비스 이용을 위하여 해당 서비스에 결제수단 및 결제
          정보를 입력하고, 이를 저장할 수 있습니다. 저장된 결제수단 및 결제
          정보는 정기결제나 다음 결제 시에 사용됩니다
        </li>
        <li>
          3. 회원은 타인의 결제수단을 임의로 사용하여서는 안됩니다. 타인의
          결제수단을 임의 사용함으로써 발생하는 회사, 결제수단의 적법한 소유자,
          기타 해당 결제와 관련된 제3자의 손실이나 손해에 대한 책임은 회원에게
          있습니다.
        </li>
        <li>
          4. 유료 서비스 이용을 위한 결제와 관련하여 회원이 입력한 정보와
          관련하여 발생한 문제에 대한 책임과 불이익은 회원이 부담하여야 합니다.
        </li>
        <li>
          5. 회원은 유료 서비스 이용요금 결제 시 정당하고, 적법한 사용권한을
          가지고 있는 결제수단을 사용하여야 하며, 회사는 그 여부를 확인할 수
          있습니다. 또한 회사는 회원이 사용한 결제수단의 적법성 등에 대한 확인이
          완료될 때까지 거래 진행을 중지하거나 해당 거래를 취소할 수 있습니다.
        </li>
        <li>
          6. 회사의 정책 및 제1항의 결제수단을 제공하는 업체(이동통신사, 카드사,
          구글플레이, 애플스토어 등)의 기준이나 법령에 따라 회원 당 월 누적
          결제액 및 충전한도가 제한될 수 있습니다. 해당 기준을 초과한 경우
          유료서비스의 추가 이용이 불가능할 수 있습니다.
        </li>
        <li>
          7. 회원이 모바일 애플리케이션(이하 "앱")을 통해 유료 서비스를 이용할
          경우, 인앱결제(In-App Purchase) 방식으로 결제가 이루어질 수 있으며, 이
          경우 결제는 Apple App Store, Google Play Store 등 각 앱마켓의 결제
          정책에 따릅니다. 회사는 앱마켓의 정책에 따라 결제·청약철회·환불 등에
          직접 관여할 수 없으며, 관련 요청은 해당 앱마켓을 통해 처리되어야
          합니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>제 17 조 유료서비스의 청약철회</PolicyArticleTitle>
      <PolicyList>
        <li>
          1. 회원은 본 약관에 따라 유료 서비스를 이용하기 위해 유료 결제를 한
          날로부터 7일 이내에 회사에 대해 서비스의 이용에 관한 청약을 철회할 수
          있습니다. 다만, 회사가 회원에게 사전에 합의한 내용과 다르게 서비스를
          제공하거나 서비스를 제공하지 아니하는 경우, 회원은 유료 결제를 한
          날로부터 3개월 이내 또는 해당 사실을 알거나 알 수 있었던 날로부터 30일
          이내에 회사에 대해 서비스의 이용에 관한 청약을 철회할 수 있습니다. 단,
          Apple App Store, Google Play Store 등 앱마켓을 통한 인앱결제에
          대해서는 각 앱마켓의 청약철회 및 환불 정책이 우선 적용되며, 회원은
          관련 요청을 해당 앱마켓을 통해 직접 진행해야 합니다.
        </li>
        <li>
          2. 제1항에도 불구하고, 회원은 다음 각 호의 어느 하나에 해당하는
          경우에는 청약철회를 할 수 없습니다.
          <ul>
            <li>
              ① 콘텐츠의 내용을 확인하기 위하여 포장 등을 훼손한 경우를
              제외하고, 이용자에게 책임 있는 사유로 콘텐츠가 멸실 또는 훼손된
              경우
            </li>
            <li>
              ② 이용자의 사용 또는 일부 소비에 의하여 콘텐츠의 가치가 현저히
              감소한 경우
            </li>
            <li>
              ③ 시간의 경과에 의하여 재판매가 곤란할 정도로 콘텐츠의 가치가
              현저히 감소한 경우
            </li>
            <li>④ 복제가 가능한 콘텐츠의 포장을 훼손한 경우</li>
            <li>
              ⑤ 디지털 콘텐츠 제공이 개시된 경우(다만, 가분적 디지털 콘텐츠로
              구성된 계약의 경우에는 제공이 개시되지 아니한 부분에 대하여는
              청약철회 등을 할 수 있습니다.)
            </li>
            <li>
              ⑥ 이용자의 주문에 의하여 콘텐츠가 개별적으로 생산되는 경우 등
              청약철회 등을 인정하면 사업자에게 회복할 수 없는 중대한 피해가
              예상되는 경우로서 사전에 당해 거래에 대하여 별도로 그 사실을
              고지하고 이용자의 서면(전자문서를 포함한다)에 의한 동의를 얻은
              경우
            </li>
          </ul>
        </li>
        <li>
          3. 회사는 청약철회가 불가능한 서비스나 콘텐츠에 대해서는 다음 각 호의
          조치를 취합니다.
          <ul>
            <li>
              ① 청약철회가 불가능한 유료 서비스에 해당한다는 사실을 표시사항에
              포함
            </li>
            <li>
              ② 시용상품을 제공하거나 한시적 또는 일부 이용 등의 방법을 제공
            </li>
          </ul>
        </li>
        <li>
          4. 회원은 타인의 결제수단을 임의로 사용하회원이 유료서비스를 이용하여
          적립금, 마일리지, 쿠폰 등의 혜택을 지급받은 경우 청약철회 시 이를
          회사에 반환하여야 합니다.
        </li>
        <li>
          5. 청약철회 및 환불 요청은 각 서비스에서 제공하는 메뉴 또는
          고객센터에서 할 수 있습니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>
        제 18 조 유료서비스 이용 계약 해제, 해지 및 이용제한
      </PolicyArticleTitle>
      <PolicyList>
        <li>
          1. 회원은 다음 각 호의 사유가 있을 때 이용계약을 해지 또는 해제할 수
          있습니다. 계약의 해제, 해지는 회원이 전화, 전자우편 등으로 그 의사를
          표시한 때에 효력이 발생하고, 회사는 회원의 의사표시를 수신한 후
          지체없이 그 사실을 회원에게 회신합니다.
          <ul>
            <li>
              ① 유료 서비스 이용 회원이 본 약관의 개정, 변경에 동의하지 않아
              회원 탈퇴를 하거나 유료 서비스 이용계약을 해지하는 경우
            </li>
            <li>
              ② “방문판매 등에 관한 법률”에 따른 계속거래에 해당하는 유료
              서비스의 이용계약을 해지하는 경우
            </li>
            <li>
              ③ 기타 관련 법령이나 본 약관에 따라 회원이 유료 서비스 이용계약을
              해지 또는 해제하고자 하는 경우
            </li>
          </ul>
        </li>
        <li>
          2. 회사는 회원이 본 약관에 명시된 회원의 의무를 위반하였을 경우, 또는
          그러한 위법·부당한 행위가 있는 것으로 의심될 만한 상당한 이유가 있는
          경우 회원과의 유료 서비스 이용계약을 해제, 해지하거나 또는 기간을
          정하여 유료 서비스의 이용을 제한할 수 있습니다. 계약의 해제, 해지는
          회사가 자신이 정한 통지 방법에 따라 회원에게 그 의사를 표시한 때에
          효력이 발생합니다.
        </li>
        <li>
          3. 회사의 해제, 해지 및 이용제한에 대하여 회원은 회사가 정한 절차에
          따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 회사가
          인정하는 경우, 회사는 즉시 서비스의 이용을 재개합니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>
        제 19 조 유료서비스 이용요금의 환불 및 제한
      </PolicyArticleTitle>
      <PolicyList>
        <li>
          1. 회사가 이용요금을 환불하는 경우 기본적으로 아래 각 호에 따릅니다.
          단, 회사는 개별 유료서비스에 대해 별도의 상세 환불정책을 운영할 수
          있으며, 이 경우 아래 각 호 및 본 약관의 다른 내용에도 불구하고 상세
          환불정책에서 정한 바를 따릅니다. 별도의 상세 환불정책이 적용되는 경우
          회사는 해당 유료서비스 구매 과정에서 주의사항으로 기재하는 등 적절한
          방식을 통해 안내합니다.
          <ul>
            <li>
              ① 해당 유료서비스가 결제 후 1회의 이용만으로 서비스의 이용이나
              구매가 완료되는 서비스인 경우 : 해당 서비스를 이용(제공이 개시된
              것을 포함)한 후에는 환불 불가능. 단, 1회 구매 완료 후 사용기한의
              정함이 없는 유료서비스가 회사의 귀책사유로 제공이 어려운 경우
              구매완료일로부터 1개월 이내인 경우에 한하여 환불
            </li>
            <li>
              ② 해당 유료서비스가 정기결제형 유료서비스인 경우 : 해지일로부터
              이용일수에 해당하는 금액과 총 남은 유료서비스 이용으로부터 얻은
              이익 및 환불 수수료(10% 또는 1,000원 중 큰 금액)를 제외한 금액
              환불. (단, 유료 서비스 이용 개시일로부터 7일 이내에 해지를
              요구하는 경우 이용일수에 해당하는 금액만을 제외하고 환불)
            </li>
            <li>
              ③ 인앱결제를 통해 구매한 유료서비스인 경우 : 해당 앱마켓의
              환불정책이 우선 적용되며, 회사는 직접 환불을 진행할 수 없습니다.
            </li>
          </ul>
        </li>
        <li>
          2. 회사는 이용요금을 환불함에 있어서 회원이 신용카드 또는 전자화폐
          등의 결제수단으로 재화 등의 대금을 지급한 때에는 지체 없이 당해
          결제수단을 제공한 사업자로 하여금 재화 등의 대금의 청구를 정지 또는
          취소하도록 요청합니다. 다만, 수납확인이 필요한 결제수단의 경우 및
          회원이 유료서비스 이용으로부터 얻은 이익에 해당하는 금액을 공제하는
          경우에는 그러하지 아니할 수 있습니다.
        </li>
        <li>
          3. 회사, 유료서비스 등의 대금을 지급 받은 자 또는 회원과 유료서비스
          이용계약을 체결한 자가 동일인이 아닌 경우에 각자는 청약철회 또는
          계약해제, 해지로 인한 대금환급과 관련한 의무의 이행에 있어서 연대하여
          책임을 집니다.
        </li>
        <li>
          4. 회사가 제18조 제2항에 따라 회원의 유료 서비스 이용을 제한하거나 본
          계약을 해제, 해지하는 경우 회사는 회원에게 일체의 환불을 하지
          않습니다.
        </li>
      </PolicyList>

      <PolicySectionTitle>&lt;제 5 장&gt; 기타</PolicySectionTitle>
      <PolicyArticleTitle>제 20 조 손해배상 등</PolicyArticleTitle>
      <PolicyList>
        <li>
          1. 회사는 관련 법령상 허용되는 한도 내에서 서비스와 관련하여 본 약관에
          명시되지 않은 어떠한 구체적인 사항에 대한 약정이나 보증을 하지
          않습니다. 또한, 회사는 CP(Contents Provider)가 제공 또는 공공데이터 등
          외부에서 제공하는 데이터를 연동하거나 회원이 작성하는 등의 방법으로
          서비스에 게재된 정보, 자료, 사실의 신뢰도, 정확성 등에 대해서는 보증을
          하지 않으며, 회사의 과실 없이 발생된 회원의 손해에 대해서는 책임을
          부담하지 아니합니다.
        </li>
        <li>
          2. 회사는 회사의 과실로 인하여 회원이 손해를 입게 될 경우 본 약관 및
          관련 법령에 따라 회원의 손해를 배상하겠습니다. 다만 회사는 회사의 과실
          없이 발생된 아래와 같은 손해에 대해서는 책임을 부담하지 않습니다. 또한
          회사는 법률상 허용되는 한도 내에서 간접 손해, 특별 손해, 결과적 손해,
          징계적 손해 및 징벌적 손해에 대한 책임을 부담하지 않습니다.
          <ul>
            <li>① 천재지변 또는 이에 준하는 불가항력의 상태에서 발생한 손해</li>
            <li>② 회원의 귀책사유로 서비스 이용에 장애가 발생한 경우</li>
            <li>③ 서비스에 접속 또는 이용과정에서 발생하는 개인적인 손해</li>
            <li>
              ④ 제3자가 불법적으로 회사의 서버에 접속하거나 서버를 이용함으로써
              발생하는 손해
            </li>
            <li>
              ⑤ 제3자가 회사 서버에 대한 전송 또는 회사 서버로부터의 전송을
              방해함으로써 발생하는 손해
            </li>
            <li>
              ⑥ 제3자가 악성 프로그램을 전송 또는 유포함으로써 발생하는 손해
            </li>
            <li>
              ⑦ 전송된 데이터의 생략, 누락, 파괴 등으로 발생한 손해, 명예훼손 등
              제3자가 서비스를 이용하는 과정에서 발생된 손해
            </li>
            <li>⑧ 기타 회사의 고의 또는 과실이 없는 사유로 인해 발생한 손해</li>
          </ul>
        </li>
        <li>
          3. 회사는 회원이 서비스를 이용하여 기대하는 수익 등을 상실한 것에
          대하여 책임을 지지 않으며 그 밖에 서비스를 통하여 얻은 자료로 인한
          손해 등에 대하여도 책임을 지지 않습니다.
        </li>
        <li>
          4. 회사는 회사의 과실이 없는 한 회원 상호간 또는 회원과 제3자 상호간에
          서비스를 매개로 발생한 분쟁에 대해서는 개입할 의무가 없으며 이로 인한
          손해를 배상할 책임도 없습니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>제 21 조 통지 및 공지</PolicyArticleTitle>
      <PolicyText>
        회사는 회원과의 의견 교환을 소중하게 생각합니다. 회원은 언제든지
        고객센터에 방문하여 의견을 개진할 수 있습니다. 서비스 이용자 전체에 대한
        공지는 일주일(7일) 이상 서비스 공지사항에 게시함으로써 효력이
        발생합니다. 회원에게 중대한 영향을 미치는 사항의 경우에는 계정에 등록된
        이메일 주소로 이메일 발송, 앱 푸시 알림 메시지를 발송하는 등의 별도의
        전자적 수단 또는 회원이 등록한 휴대전화번호로 문자메시지 발송 등의
        방법으로 개별적으로 알려 드리겠습니다.
      </PolicyText>
      <PolicyArticleTitle>제 22 조 분쟁의 해결</PolicyArticleTitle>
      <PolicyText>
        본 약관 또는 서비스는 대한민국법령에 의하여 규정되고 이행됩니다. 서비스
        이용과 관련하여 회사와 회원 간에 분쟁이 발생하면 이의 해결을 위해 성실히
        협의할 것입니다. 그럼에도 불구하고 해결되지 않으면 민사소송법의
        관할법원에 소를 제기할 수 있습니다.
      </PolicyText>
      <PolicyArticleTitle>제 23 조 규정의 준용</PolicyArticleTitle>
      <PolicyText>
        본 약관에 명시되지 않은 사항에 대해서는 관련법령에 의하고, 법에 명시되지
        않은 부분에 대하여는 관습에 의합니다.
      </PolicyText>
      <PolicyArticleTitle>부칙</PolicyArticleTitle>
      <PolicyText>
        본 약관은 2025년 07월 10일부터 적용됩니다. 단, 본 약관의 공지
        시점으로부터 적용일 전일까지 기간 동안에 가입한 신규회원에 대해서는 회원
        가입 시부터 본 약관이 적용됩니다.
      </PolicyText>
    </PolicyContainer>
  );
};

export default Service;
